var React = require('react');

function BlobContactInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M541.326 51.508C501.953 4.27316 392.939 34.4094 315.465 20.3168C249.88 8.38691 211.772 -13.0383 143.415 10.7352C72.8937 35.261 52.2766 66.7722 32.1015 118.865C11.1243 173.029 -21.2757 232.709 19.6805 272.858C63.3185 315.637 150.501 317.045 231.721 314.551C330.136 311.53 458.657 363.576 527.532 305.058C598.676 244.614 589.002 108.706 541.326 51.508Z","fill":"#4DD996"}));
}

BlobContactInline.defaultProps = {"preserveAspectRatio":"none","width":"579","height":"333","viewBox":"0 0 579 333","fill":"none"};

module.exports = BlobContactInline;

BlobContactInline.default = BlobContactInline;
